import { render, staticRenderFns } from "./FormationAreaForm.vue?vue&type=template&id=5c59ad46&scoped=true"
import script from "./FormationAreaForm.vue?vue&type=script&lang=js"
export * from "./FormationAreaForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=5c59ad46&prod&scoped=true&lang=css&external"
import style1 from "./FormationAreaForm.vue?vue&type=style&index=1&id=5c59ad46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c59ad46",
  null
  
)

export default component.exports